export var VoucherStatus;
(function (VoucherStatus) {
    VoucherStatus["Valid"] = "valid";
    VoucherStatus["Redeemed"] = "redeemed";
})(VoucherStatus || (VoucherStatus = {}));
